import { Modal } from "tailwindcss-stimulus-components"
import TomSelect from "tom-select"

export default class extends Modal {

    connect() {
        super.connect();
        this.isDragging = false;
        this.mouseDownTarget = null;
        this.mouseDownTime = null;

        // Track mousedown/mouseup/mousemove für Drag & Drop Erkennung
        this.boundHandleMouseDown = this.handleMouseDown.bind(this);
        this.boundHandleMouseUp = this.handleMouseUp.bind(this);
        this.boundHandleMouseMove = this.handleMouseMove.bind(this);

        this.element.addEventListener('mousedown', this.boundHandleMouseDown);
        this.element.addEventListener('mouseup', this.boundHandleMouseUp);
        document.addEventListener('mousemove', this.boundHandleMouseMove);
    }

    disconnect() {
        this.element.removeEventListener('mousedown', this.boundHandleMouseDown);
        this.element.removeEventListener('mouseup', this.boundHandleMouseUp);
        document.removeEventListener('mousemove', this.boundHandleMouseMove);
        super.disconnect();
    }

    handleMouseDown(event) {
        this.mouseDownTarget = event.target;
        this.mouseDownTime = Date.now();
        this.isDragging = false;
    }

    handleMouseMove(event) {
        // Wenn mousedown aktiv war und sich die Maus bewegt, ist es ein Drag
        if (this.mouseDownTarget && event.buttons !== 0) {
            this.isDragging = true;
        }
    }

    handleMouseUp(event) {
        // Wenn das Ziel-Element sich geändert hat oder genug Zeit vergangen ist, war es wahrscheinlich ein Drag
        if (this.mouseDownTarget &&
            (this.mouseDownTarget !== event.target ||
             (this.mouseDownTime && Date.now() - this.mouseDownTime > 100))) {
            // Kurze Verzögerung, damit Drag-Events verarbeitet werden können
            setTimeout(() => {
                this.isDragging = false;
            }, 100);
        } else {
            this.isDragging = false;
        }
        this.mouseDownTarget = null;
        this.mouseDownTime = null;
    }

    open(e) {
        super.open(e);

        // set focus to the first input element in the modal.
        let input = this.element.querySelector('input');
        // if there is a tomselect element, output the first one to the console
        let tomselect = this.element.querySelector('.ts-control');
        
        if (tomselect) {
            // get the existing tomselect instance
            tomselect.focus();
        } else if (input) {
            input.focus();
        }
    }

    submitEnd(event) {
        // Handle form submission end
        if (event.detail.success) {
            // Close modal on successful submission
            this.close();
            
            // Check if this is a todo form and open the todos tab
            this.openTodosTab();
        } else {
            // Keep modal open on error
        }
    }

    openTodosTab() {
        // Legacy `tabs` (tailwindcss-stimulus-components) und `customer-detail-tabs` (replaceState, keine Scroll-Sprünge)
        const tabsController =
            document.querySelector('[data-controller~="tabs"]') ||
            document.querySelector('[data-controller*="customer-detail-tabs"]');
        if (!tabsController) return;

        const tabLinks = tabsController.querySelectorAll(
            'a[data-tabs-target="tab"], a[data-customer-detail-tabs-target="tab"]'
        );
        const href = (tab) => tab.getAttribute("href") || "";
        const todosTab = Array.from(tabLinks).find((tab) => {
            const t = tab.textContent.trim();
            return (
                t.includes("Todos") ||
                t.includes("Aufgaben") ||
                tab.id === "customer_todos_tab" ||
                tab.id === "contact_todos_tab" ||
                href(tab) === "#todos" ||
                href(tab) === "#customer_todos_tab" ||
                href(tab) === "#applicant_tab_todos" ||
                href(tab) === "#contact_tab_todos"
            );
        });

        if (todosTab) todosTab.click();
    }

    close() {
        super.close();
        // Reset form when closing, but skip reset if preserveFormData is set to true
        const shouldPreserveData = this.element.dataset.preserveFormData === 'true';

        if (!shouldPreserveData) {
            const form = this.element.querySelector('form');
            if (form) {
                form.reset();
            }
        }
    }

    closeBackground(event) {
        // Verhindere das Schließen bei Drag & Drop, geöffneten Selects oder gedrückter Maustaste
        if (this.isInteracting(event)) {
            return;
        }

        // Finde das Container-Element
        const container = this.element.querySelector('[data-tmodal-target="container"]');

        // Nur schließen, wenn wirklich auf den Hintergrund (Container) geklickt wurde
        // und nicht auf den Modal-Inhalt
        if (container && event.target === container) {
            super.closeBackground(event);
        }
    }

    isInteracting(event) {
        // Prüfe ob Drag & Drop aktiv ist (mousedown auf einem Element, mouseup auf anderem)
        if (this.isDragging) {
            return true;
        }

        // Prüfe ob Maustaste gedrückt ist
        if (event.buttons && event.buttons !== 0) {
            return true;
        }

        // Prüfe ob ein Select-Dropdown geöffnet ist (TomSelect, native Select)
        const activeSelect = this.element.querySelector('.ts-dropdown:not(.hidden), .ts-dropdown-content, select:focus, .select2-container--open');
        if (activeSelect) {
            return true;
        }

        // Prüfe ob ein Drag-Element aktiv ist
        const draggingElement = document.querySelector('.is-dragging, .sortable-drag, .dragging, [dragging="true"]');
        if (draggingElement) {
            return true;
        }

        // Prüfe ob das geklickte Element innerhalb des Modal-Inhalts ist
        const modalContent = this.element.querySelector('.inline-block');
        if (modalContent && modalContent.contains(event.target)) {
            return true; // Klick ist innerhalb des Modal-Inhalts
        }

        // Prüfe ob das geklickte Element ein interaktives Element ist (Input, Select, Button, etc.)
        const interactiveElements = ['INPUT', 'SELECT', 'BUTTON', 'TEXTAREA', 'A', 'LABEL'];
        if (interactiveElements.includes(event.target.tagName) ||
            event.target.closest('.ts-control, .ts-dropdown, button, input, select, textarea, a')) {
            return true;
        }

        return false;
    }
}